import { motion, AnimatePresence } from 'framer-motion';

interface CountdownUnitProps {
  digit: string;
  label: string;
  styles: {
    readonly [key: string]: string;
  };
  digitColor?: string;
  labelColor?: string;
  borderColor?: string;
  backgroundColor?: string;
}

export default function CountdownUnit({ digit, label, styles, digitColor, labelColor, borderColor, backgroundColor }: CountdownUnitProps) {
  return (
    <div className={styles.countdownUnit}>
      <div className={styles.digitContainer} style={{ borderColor: borderColor, backgroundColor: backgroundColor }}>
        <AnimatePresence mode="popLayout">
          <motion.span
            key={digit}
            initial={{ y: '100%', opacity: 0 }}
            animate={{ y: '0%', opacity: 1 }}
            exit={{ y: '-100%', opacity: 0 }}
            transition={{ type: 'spring', stiffness: 300, damping: 30, duration: 0.3 }}
            className={styles.digit}
            style={{ color: digitColor }}
          >
            {digit}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className={styles.label} style={{ color: labelColor }}>{label}</span>
    </div>
  );
}
